import { render, staticRenderFns } from "./new_detail.vue?vue&type=template&id=f880b7e4&"
import script from "./new_detail.vue?vue&type=script&lang=js&"
export * from "./new_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports